import React from "react";
import './FloatingContactButtons.css';
import { ReactComponent as WhatsAppIcon } from "../../assets/icon/whatsApp.svg";
import { ReactComponent as PhoneIcon } from "../../assets/icon/callingIcon.svg";
import { ReactComponent as EmailIcon } from "../../assets/icon/emailIcon.svg";

export default function FloatingContactButtons() {
  return (
    <div className="contact-fab-group" aria-label="Quick contact options">
      {/* Call */}
      <a
        href="tel:+919022413416"          // your phone number
        className="contact-fab contact-fab--call"
        aria-label="Call Limitless Healthcare"
      >
        <PhoneIcon height={25} width={25} />
      </a>

      {/* WhatsApp */}
      <a
        href="https://wa.me/919022413416" // full number, no + or spaces
        target="_blank"
        rel="noopener noreferrer"
        className="contact-fab contact-fab--whatsapp"
        aria-label="Chat on WhatsApp"
      >
       <WhatsAppIcon height={25} width={25} />
      </a>

      {/* Email */}
      <a
        href="mailto:limitlesshealthcare10@gmail.com" // your email
        className="contact-fab contact-fab--mail"
        aria-label="Send us an email"
      >
        <EmailIcon height={25} width={25} />
      </a>
    </div>
  );
}
